const numberConverter = (value) => {
    return parseFloat(value);
};
const intConverter = (value) => {
    return parseInt(value, 10);
};
export const fieldConverters = {
    string: {
        databaseConverter: (value) => value,
        previewConverter: (value) => value,
    },
    chess_puzzle: {
        databaseConverter: (value) => value,
        previewConverter: (value) => value,
    },
    number: {
        databaseConverter: numberConverter,
        previewConverter: numberConverter,
    },
    int: {
        databaseConverter: intConverter,
        previewConverter: intConverter,
    },
    image: {
        databaseConverter: (value) => value,
        previewConverter: (value) => {
            if (value) {
                return value.data;
            }
            else {
                return new Blob();
            }
        },
    },
    audio: {
        databaseConverter: (value) => value,
        previewConverter: (value) => {
            if (value) {
                return value.data;
            }
            else {
                return new Blob();
            }
            // return '(audio)';
        },
    },
    midi: {
        databaseConverter: (value) => value,
        previewConverter: (value) => value,
    },
    markdown: {
        databaseConverter: (value) => value,
        previewConverter: (value) => value,
    },
    uploads: {
        databaseConverter: (value) => value,
        previewConverter: (value) => value,
    },
};
//# sourceMappingURL=fieldConverters.js.map